import templateComponents from '../../../Template/theme/components'
import scorecard from './scorecard'
import quickview from './quickview'

export default {
    ...templateComponents,
    quickview,
    scorecard
}


// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/theme/components/index.js